import { Link } from "react-router-dom";
import { Container, Grid, Typography, TextField, Button } from "@mui/material";
import { Controller } from "react-hook-form";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import phoneSchema from "../validationSchemas/phoneSchema";
import NotNullFieldFootnote from "./NotNullFieldFootnote";

const schema = yup.object().shape({
  name: yup.string().min(3).max(29).required(),
  surname: yup.string().min(3).max(29).required(),
  email: yup.string().email().max(60).required(),
  description: yup.string().min(10).required(),
  phoneNumber: phoneSchema
});

function RegistrationForm(props) {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <Container maxWidth="xs">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h6" margin="40px 0 20px 0">
            Create New account
          </Typography>
        </Grid>
      </Grid>
      <form onSubmit={handleSubmit(props.onSubmit)}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Controller
              name="name"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  error={Boolean(errors.name?.message)}
                  fullWidth={true}
                  type="text"
                  label="Name *"
                  variant="filled"
                  helperText={errors.name?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="surname"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  error={Boolean(errors.surname?.message)}
                  fullWidth={true}
                  type="text"
                  label="Surname *"
                  variant="filled"
                  helperText={errors.surname?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="email"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  error={Boolean(errors.email?.message)}
                  fullWidth={true}
                  type="email"
                  label="Email *"
                  variant="filled"
                  helperText={errors.email?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="phoneNumber"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  error={Boolean(errors.phoneNumber?.message)}
                  fullWidth={true}
                  type="text"
                  label="Phone number"
                  variant="filled"
                  helperText={errors.phoneNumber?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="description"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  multiline
                  fullWidth={true}
                  rows={3}
                  placeholder="Enter your company and position details *"
                  error={Boolean(errors.description?.message)}
                  helperText={errors.description?.message}
                />
              )}
            />
          </Grid>
          <NotNullFieldFootnote/>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={props.isLoading}
                >
                  Registration
                </Button>
              </Grid>
              <Grid item>
                <Button color="inherit" component={Link} to="/login">
                  Already have an account?
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}

export default RegistrationForm;
